import TYPES from '@/modules/shared/types';

// Domain
import { CustomerKuspitCredentialsRepository } from '../../domain/repository';
import { CustomerKuspitCredentialsEntity } from '../../domain/entities/customer-kuspit-credentials-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class CustomerKuspitCredentialsHttpRepository
implements CustomerKuspitCredentialsRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/kuspit/account-credentials/`;

  execute(): Promise<CustomerKuspitCredentialsEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
